var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "14px",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "db_empty",
    transform: "translate(-692.000000, -664.000000)",
    fill: "#B2B1AD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/copy",
    transform: "translate(690.000000, 662.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4374471,6.66365625 L17.0065721,5.62415625 C15.7313846,6.15346875 14.2626971,5.54484375 13.7345096,4.26853125 L12.6955721,4.69940625 C12.9515096,5.31703125 12.9515096,5.99821875 12.6955721,6.61640625 C12.4390721,7.23459375 11.9575721,7.71609375 11.3393846,7.97203125 L11.7702596,9.01153125 C12.6387596,8.65153125 13.3216346,7.98440625 13.7001971,7.12715625 C14.1906971,8.35846875 14.1816971,9.70734375 13.6731971,10.9347188 C13.1562596,12.1834688 12.1831346,13.1560313 10.9343846,13.6735313 C9.68507215,14.1910313 8.31032215,14.1910313 7.06100965,13.6735313 C5.81225965,13.1560313 4.83969715,12.1840313 4.32275965,10.9347188 C3.25513465,8.35678125 4.48363465,5.38959375 7.06157215,4.32196875 C7.68257215,4.06490625 8.33000965,3.94621875 8.99769715,3.93721875 L8.99769715,2.81221875 C8.19894715,2.82571875 7.38894715,2.96859375 6.63069715,3.28246875 C3.48013465,4.58803125 1.97825965,8.21390625 3.28325965,11.3650313 C3.91550965,12.8916563 5.10463465,14.0807813 6.63069715,14.7130313 C7.39400965,15.0291563 8.19613465,15.1872188 8.99769715,15.1872188 C9.79982215,15.1872188 10.6019471,15.0291563 11.3646971,14.7130313 C12.8913221,14.0807813 14.0804471,12.8910938 14.7126971,11.3650313 C15.3387596,9.85303125 15.3426971,8.18915625 14.7284471,6.67434375 C15.1480721,6.84084375 15.5946971,6.93984375 16.0531346,6.93984375 C16.5149471,6.93984375 16.9846346,6.85096875 17.4374471,6.66365625",
    id: "icon"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.e8c9a13108a3dcb6b02679a824e85e0d.svg";
export { ForwardRef as ReactComponent };